import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import { encode } from 'js-base64';

import { PayButton } from '../../../PayButton';

const CURRENCIES = ['USD', 'EUR', 'RUB', 'UAH', 'BYN', 'KZT'];
const PAYMENT_URL = 'https://www.liqpay.ua/api/3/checkout';
const ACTIONS = ['pay', 'hold', 'subscribe', 'paydonate', 'auth'];
const VERSION = 3;

const propTypes = {
    publicKey: PropTypes.string.isRequired,
    action: PropTypes.oneOf(ACTIONS),
    amount: PropTypes.number.isRequired,
    currency: PropTypes.oneOf(CURRENCIES).isRequired,
    description: PropTypes.string.isRequired,
    orderId: PropTypes.string.isRequired,
    resultUrl: PropTypes.string,
    serverUrl: PropTypes.string,
    disabled: PropTypes.bool,
    createSignature: PropTypes.func.isRequired,
};

const defaultProps = {
    action: ACTIONS[0],
};

function LiqpayButton({
    publicKey,
    action,
    amount,
    currency,
    description,
    orderId,
    createSignature,
    resultUrl,
    serverUrl,
    disabled: rawDisabled,
}) {
    const [disabled, setDisabled] = useState(true);
    const [signature, setSignature] = useState('');
    const isDisabled = disabled || rawDisabled;

    const data = useMemo(() => {
        const params = {
            public_key: publicKey,
            version: VERSION,
            action,
            amount,
            currency,
            description,
            order_id: orderId,
        };
        if (resultUrl) params['result_url'] = resultUrl;
        if (serverUrl) params['server_url'] = serverUrl;

        return encode(JSON.stringify(params));
    }, [publicKey, action, amount, currency, description, orderId]);

    useEffect(() => {
        async function request() {
            if (!rawDisabled) {
                setDisabled(true);

                try {
                    const json = await createSignature({ data });

                    setSignature(json.signature);
                } finally {
                    setDisabled(false);
                }
            }
        }

        void request();
    }, [data]);

    return (
        <form method="POST" action={PAYMENT_URL}>
            <input type="hidden" name="data" value={data} />
            <input type="hidden" name="signature" value={signature} />

            <PayButton disabled={isDisabled} provider="liqpay" />
        </form>
    );
}

LiqpayButton.propTypes = propTypes;
LiqpayButton.defaultProps = defaultProps;

export default LiqpayButton;
